import { EntitiesResponse, Entity, EntityTypesResponse } from '@/types/entity'
import { defineStore } from 'pinia'

interface States {
  entities: Ref<EntitiesResponse | null>
  entityData: Ref<Entity | null>
  entityTypes: Ref<EntityTypesResponse | null>
}

export const useEntityStore = defineStore('entity', () => {
  const states: States = {
    entities: ref(null),
    entityData: ref(null),
    entityTypes: ref(null),
  }

  const resetStore = () => {
    states.entities.value = null
    states.entityTypes.value = null
  }

  return { ...states, resetStore }
})
